import { hubDailyReportMutationList, } from './types';
const mutations = {
    [hubDailyReportMutationList.SET_REPORT_TYPE](state, type) {
        state.reportType = type;
    },
    [hubDailyReportMutationList.SET_DETAIL_DATE](state, date) {
        state.detailDate = date;
    },
    [hubDailyReportMutationList.SET_FILTER_OPTION]({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    [hubDailyReportMutationList.RESET_FILTER_OPTIONS](state) {
        state.filterOption = {
            fromAt: '',
            toAt: '',
        };
    },
    [hubDailyReportMutationList.SET_KEYWORD](state, keyword) {
        state.keyword = keyword;
    },
    [hubDailyReportMutationList.SET_SEARCH_TYPE](state, type) {
        state.orderMetricsDailyConditionType = type;
    },
    [hubDailyReportMutationList.GET_HUB_DAILY_REPORT](state, { report, type }) {
        // 정산 조회 요청 후 요청 완료보다 빠르게 페이지 이동 시
        // 조회 완료한 정산타입과 실제 필요한 정산타입이 다를 수 있음 이땐 노출하지 않음.
        if (state.reportType !== type) {
            state.hubDailyReport = null;
            return;
        }
        state.hubDailyReport = report;
    },
    [hubDailyReportMutationList.RESET_HUB_DAILY_REPORT](state) {
        state.hubDailyReport = null;
    },
};
export default mutations;
